/**
 * COMUNES
 */
import commons from "@/locales/languages/es_MX/view/commons";

/**
 * TALENTOS
 */
import talento from "@/locales/languages/es_MX/view/talento";

/**
 * ERRORES
 */
import errors from "@/locales/languages/es_MX/errors";

/**
 * VALIDADOR
 */
import validator from "@/locales/languages/es_MX/validator";

export default {
  view: {
    commons
    , talento
  }
  , errors
  , validator
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/index.js